import { createContext } from "react";

const usercontext=createContext()

export default usercontext;